var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.modalChangeQtyData
        ? _c("ChangeQtyModal", {
            attrs: {
              modalData: _vm.modalChangeQtyData,
              onAccept: (data) => _vm.updateDrugQty(data),
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("table", { staticClass: "table table-hover table-bordered mt-0" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _vm._l(_vm.sortedPrepNames(_vm.drugs), function (prep, index) {
              return _c("tr", [
                _c("td", [_vm._v(_vm._s(index + 1))]),
                _vm._v(" "),
                _c("td", [
                  prep.cool
                    ? _c("span", { staticClass: "icon icon-snowflake" })
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n        " +
                      _vm._s(prep.title) +
                      " (" +
                      _vm._s(prep.id) +
                      ")\n        "
                  ),
                  +prep.pack_set !== 1
                    ? _c("p", [
                        _vm._v("комплект: "),
                        _c("strong", [_vm._v(_vm._s(+prep.pack_set))]),
                        _vm._v(" з.у."),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  prep.pack_comment
                    ? _c("p", { staticClass: "pack_comment" }, [
                        _vm._v(_vm._s(prep.pack_comment)),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  prep.pack_box_comment
                    ? _c("p", { staticClass: "pack_box_comment" }, [
                        _vm._v(_vm._s(prep.pack_box_comment)),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(_vm._s(_vm.printPackSet(_vm.figures[prep.id], prep))),
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      prep.comment
                        ? _vm.printPackSet(prep.new_qty || null, prep)
                        : null
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.printPrice(prep)))]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-default comments_btn",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.openChangeDrugBlock(prep)
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "icon-fa icon-fa-edit text-center",
                      }),
                      _vm._v(" "),
                      prep.comment
                        ? _c("span", { staticClass: "badge badge-info" }, [
                            _vm._v("new"),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]),
              ])
            }),
            _vm._v(" "),
            _c("tr", [
              _c("td", { attrs: { colspan: "3" } }),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  _vm._s(
                    _vm.drugs.reduce((acc, d) => acc + _vm.figures[d.id], 0)
                  )
                ),
              ]),
              _vm._v(" "),
              _c("td"),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  _vm._s(
                    _vm.drugs.reduce((acc, d) => acc + _vm.printPrice(d), 0)
                  )
                ),
              ]),
            ]),
          ],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", { staticClass: "sticky" }, [
        _c("th", { attrs: { width: "40px" } }),
        _vm._v(" "),
        _c("th", { attrs: { width: "40px" } }),
        _vm._v(" "),
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "100px" } }, [_vm._v("Кол.")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "100px" } }, [_vm._v("Н.Кол.")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "70px" } }, [_vm._v("Сумма")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }